export enum AdvanceInvoiceStateEnums {
  open = 1,
  closed = 2
}